// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1cRth","consentsList":"PatientConsents_consentsList__3tSyS","consentsListEmpty":"PatientConsents_consentsListEmpty__3O_J6"};